import React from 'react';
import './TariffTable.css';
import { getServiceTypeName } from '../constants/serviceTypes';

const TariffTable = ({ tariffs = [], onEdit }) => {
  return (
    <div className="tariff-table">
      <div className="tariff-row tariff-header">
        <div>Название</div>
        <div>Тип</div>
        <div>Стоимость</div>
        <div>Коэффициент</div>
        <div></div>
      </div>
      {tariffs.map(t => (
        <div key={t.id} className="tariff-row">
          <div>{t.name}</div>
          <div>{getServiceTypeName(t.type)}</div>
          <div>{Number(t.value).toFixed(2)}</div>
          <div>{t.coefficient ?? 1}</div>
          <div>
            <button className="edit-button" onClick={() => onEdit(t)}>Редактировать</button>
          </div>
        </div>
      ))}
      {tariffs.length === 0 && (
        <div className="tariff-empty">Тарифы отсутствуют</div>
      )}
    </div>
  );
};

export default TariffTable;
